import { render } from "./AccountVerificationRouterOutlet.vue?vue&type=template&id=773f4f04&ts=true"
import script from "./AccountVerificationRouterOutlet.vue?vue&type=script&lang=ts"
export * from "./AccountVerificationRouterOutlet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__